import axios from "./themeInstance"

export default async () => {
  try {
    const response: any = await axios(`/themes`)
    return response.data
  } catch (error) {
    return null
  }
}
